import { Phone, Mail } from "lucide-react";

export function ContactTopBar() {
  return (
    <div className="border-b border-border bg-card text-xs text-muted-foreground">
      <div className="container mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-6 py-1.5 sm:justify-end lg:px-10">
        <a
          href="tel:+441226697325"
          className="inline-flex min-h-9 items-center gap-1.5 transition-colors hover:text-primary focus-visible:text-primary"
        >
          <Phone className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>01226 697 325</span>
        </a>
        <a
          href="mailto:info@phil-carr.co.uk"
          className="inline-flex min-h-9 items-center gap-1.5 transition-colors hover:text-primary focus-visible:text-primary"
        >
          <Mail className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>info@phil-carr.co.uk</span>
        </a>
      </div>
    </div>
  );
}
